import React, { useState, useEffect } from "react";
import BufferedVideo from "./BufferedVideo";

const messages = [
  {
    heading: "Welcome to Excellent Motors",
    subtext: "Your trusted Yamaha Dealer",
  },
  {
    heading: "Exchange Your Ride",
    subtext: "Get exchange bonus upto ₹3,000 on your old bike or scooter!",
  },
  {
    heading: "Experience Pure Performance",
    subtext: "Explore our latest Yamaha models today",
  },
];

const Banner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % messages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="pt-20 relative w-full h-screen overflow-hidden text-white">
      {/* Fullscreen Video Background */}
      {/* <video
        autoPlay
        muted
        loop
        playsInline
        poster="/images/banner.jpg" // <-- Default image for video
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
      >
        <source src="/videos/yamaha-promo.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video> */}
      <BufferedVideo />

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-20 z-10"></div>

      {/* Text Carousel */}
      {/* Text Content at Bottom */}
      <div className="absolute bottom-24 sm:bottom-20 left-1/2 transform -translate-x-1/2 z-20 text-center px-4 w-full max-w-md sm:max-w-xl">
        <div key={currentSlide} className="animate-slideInLeft duration-300 flex flex-col items-center">
          <h1 className="text-xl sm:text-3xl font-extrabold mb-1 leading-snug">
            {messages[currentSlide].heading}
          </h1>
          <p className="text-sm sm:text-lg mb-3 text-white/90">
            {messages[currentSlide].subtext}
          </p>

          <div className="flex flex-col items-center gap-3">
            <a
              href="#models"
              className="bg-yellow-500 text-blue-900 px-6 py-3 rounded-full text-base sm:text-lg font-semibold hover:bg-yellow-400 whitespace-nowrap inline-block shadow-lg"
            >
              Explore Our Models
            </a>

            <a
              href="tel:+919818922508"
              className="inline-flex flex-col items-center text-sm sm:text-base font-medium text-white/90 hover:text-yellow-300 transition-colors duration-200"
              aria-label="Call +91 9818922508"
            >
              <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-red-500 drop-shadow-sm">Call Now</span>
              <span className="mt-0.5 text-base sm:text-lg font-semibold">+91 9818922508</span>
            </a>
          </div>
        </div>
      </div>

    </section>
  );
};

export default Banner;
